const translations = {
  "users.UserName": "User name",
  "users.Email": "email",
  "users.Phone": "Phone",
  "users.DisplayName": "Display name",  
  "users.MustChangePassword": "Password must be changed",
  "users.IsActive": "Active",
  "users.AddUser": "Add user",
  "users.EditUser": "Edit user",
  "users.UserExists": "User already exists",
  "users.Role": "User role",
  "users.Employee": "Employee",  
  "users.Roles": "Group of rights",
  "pay-page-phone-text": "The code will be sent to the number which ends with figures: <d></d> If you do not use the above-mentioned number please <a> <nw> change the number remotely</nw></a> ",
  "get-sms-code-again": "Receive SMS code again",
  "payment-can-be-done-after-policy-activation": "Payment can be made from the date of activation of the poliicy (<nw><date></date></nw>)",
  "pay-phone-text-1": "The code will be sent to the number which ends with figures: ",
  "pay-phone-text-2": "If you do not use the above-mentioned number please ",
  "pay-phone-text-3": "change the number remotely ",
  "payment-date-new": "Date of payment",
  "enter-personal-number": "Enter your personal number",
  "enter-pin-code": "Enter the received 4-digit code",
  "pin": "Personal number",
  "get-code": "Receive code",
  "agreementForRegister": " I hereby confirm and give permission to Imedi L to create my user profile for Insurers’ Electronical Portal for my insurance policy and in order to get services"
};

export default translations;
